import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("tmc_embed_token") || localStorage.getItem("tmc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !err.config?.url?.includes("/auth/") && !window.location.pathname.startsWith("/embed")) {
      localStorage.removeItem("tmc_token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

const HTTP_MESSAGE = {
  400: "That request could not be completed — please check the details and try again.",
  401: "Your session has expired. Please sign in again.",
  403: "You do not have permission to do that.",
  404: "We could not find what you were looking for. It may have been removed.",
  409: "That action conflicts with the current state — refresh the page and try again.",
  413: "That file is too large to upload.",
  422: "Some of the information entered is not valid.",
  429: "Too many requests — please wait a moment and try again.",
};

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const res = e?.response;
  if (!res) return e?.code === "ERR_NETWORK" ? "We could not reach the server. Check your connection and try again." : fallback;
  const d = res.data?.detail;
  const text = typeof d === "string" ? d : d?.message || (Array.isArray(d) ? d[0]?.msg : null);
  // A deliberate, human-written server message always wins; otherwise fall back to a plain sentence.
  if (text && !/^\s*[{[]/.test(text)) return text;
  if (res.status >= 500) return "Something went wrong on our side. The team has been notified — please try again shortly.";
  return HTTP_MESSAGE[res.status] || fallback;
};

export const errDetail = (e) => {
  const res = e?.response;
  if (!res) return e?.message || null;
  const d = res.data?.detail;
  return `HTTP ${res.status} ${res.config?.method?.toUpperCase() || ""} ${res.config?.url || ""}\n${typeof d === "string" ? d : JSON.stringify(d, null, 2)}`;
};

export const mediaUrl = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const downloadBlob = async (path, filename) => {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const openBlob = async (path) => {
  const r = await api.get(path, { responseType: "blob" });
  window.open(URL.createObjectURL(r.data), "_blank", "noopener");
};
